import { render } from "./MMAssessmentResult.vue?vue&type=template&id=4222bf7b"
import script from "./MMAssessmentResult.vue?vue&type=script&lang=js"
export * from "./MMAssessmentResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__